import Pane from "components/sub-nav-retailer/Pane"
import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"
import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"
import { usePage } from "contexts/Page"
import { useSuspender } from "contexts/Suspender"
import { Suspense, lazy, startTransition, useEffect, useState } from "react"
import { Helmet } from "react-helmet-async"
import { Route, StaticRouter, Switch, useParams } from "react-router-dom"
import generateComponents from "utils/generateComponents"
import { handleVisitor } from "utils/handleVisitor"

// Buy page is removed V7-4340
// const Buy = lazy(() => import("components/retailer/Buy"))
const Purchasing = lazy(() => import("components/retailer/Purchasing"))
const Caring = lazy(() => import("components/retailer/Caring"))
const Establishment = lazy(() => import("components/retailer/Establishment"))
const Group = lazy(() => import("components/retailer/Group"))
const Guarantee = lazy(() => import("components/retailer/Guarantee"))
const Servicing = lazy(() => import("components/retailer/Servicing"))

export default function BootstrapRetailer(props) {
  const console = useConsole()
  const { controlsLayout, header, sub_nav, sub_nav_two, nofooter } = props
  let { footer } = props
  // footer = JSON.parse(JSON.stringify(footer)) // TODO wtf fix
  const locale = useLocale()
  const navigation = useNavigation()
  const params = useParams()
  let { dealer: urlDealer, establishment, section } = params
  const dealerId = +urlDealer?.toLowerCase?.()?.split?.("-")?.at?.(-1)
  const page = usePage()
  const rswi = establishment && establishment.match(/rswi_\d+-[^-]+-[^-]+/) && establishment.split("-")[0]
  section = !establishment ? section : establishment?.match?.(/rswi_\d+-[^-]+-[^-]+/) ? section : establishment
  const retailCat = navigation?.slug.startsWith("/rolex-dealers") ? "/dealer/" : "/service/"
  const isDealer = navigation?.slug.startsWith("/rolex-dealers") ? true : false
  const env = useEnv()
  const location = retailCat + (section || (rswi && "establishement") || "group")
  // console.log("🚀 ~ file: Retailer.js:42 ~ BootstrapRetailer ~ location:", location)
  const locate = (rswi && "establishement") || "group"
  // console.log("🚀 ~ file: Retailer.js:35 ~ BootstrapRetailer ~ dealerId:", dealerId, rswi)

  const [[err, { retailer /*, title, description, image, searchimage*/ }], retailerSSR] = useSuspender(
    ["dealer", urlDealer, rswi].filter(Boolean),
    async () => {
      if (dealerId) {
        // url contains the dealer
        try {
          const [dealer, establishment] = await Promise.all(
            [
              !dealerId
                ? Promise.reject(new Error("missing dealer Id"))
                : Promise.resolve(
                    new URL(
                      `/app/dealer/light/jsFront?dealerId=${dealerId}&brand=RLX,RCPO&establishmentsDetails=true&countryCodeGeofencing=ALL&langCode=${locale.current.codes.www}`,
                      env.retailers
                    )
                  )
                    .then(url => new Request(url))
                    .then(request => fetch(request))
                    .then(response => response.json())
                    .then(data => data?.at?.(0) ?? data),
              rswi &&
                Promise.resolve(
                  new URL(
                    new URL(
                      `/app/establishment/light/jsFront?brand=RLX,RCPO&rswi=${rswi}&countryCodeGeofencing=ALL&langCode=${locale.current.codes.www}`,
                      env.retailers
                    )
                  )
                )
                  .then(url => new Request(url))
                  .then(request => fetch(request))
                  .then(response => response.json()),
            ].filter(Boolean)
          ).then(async ([dealer, establishment]) => {
            if (dealer.shortName) dealer.name = dealer.shortName // AZ-864
            return [dealer, establishment]
          })
          // console.log("🚀 ~ file: Retailer.js:75 ~ .then ~ establishment:", establishment)

          if (urlDealer.toLowerCase() !== dealer.urlRolexV7.toLowerCase()) throw new Error("dealer name/id mismatch")
          if (establishment && establishment.type === "SERVICECENTER") throw new Error("type mismatch")

          // console.log("🚀 ~ file: Retailer.js:75 ~ .then ~ dealer.urlRolexV7:", dealer.urlRolexV7)
          // if on a group page for a non group establishment, redirect
          if (!params.establishment && dealer.nbrEstablishment === 1 && !establishment)
            throw { redirect: navigation.localize("/rolex-dealers/" + dealer.establishments[0].urlRolexV7) }
          return [null, { retailer: { dealer, establishment } /*, title, description, image, searchimage*/ }]
        } catch (err) {
          return [err, {}]
        }
      } else if (!dealerId && rswi) {
        // some urls only contain the rswi
        try {
          const url_2 = await Promise.resolve(
            new URL(new URL(`/app/establishment/light/jsFront?rswi=${rswi}&countryCodeGeofencing=ALL&langCode=${locale.current.codes.www}`, env.retailers))
          )
          const request_2 = new Request(url_2)
          const response_2 = await fetch(request_2)
          const establishment_1 = await response_2.json()
          console.log("🚀 ~ file: Retailer.js:98 ~ establishment_1:", establishment_1)
          const [dealer_1, establishment_2] = [establishment_1, establishment_1]
          if (establishment_2.type !== "SERVICECENTER") throw new Error("type mismatch")

          dealer_1.name ??= dealer_1.nameTranslated
          return [null, { retailer: { dealer: dealer_1, establishment: dealer_1 } /*, title, description, image, searchimage*/ }]
        } catch (err_1) {
          return [err_1, {}]
        }
      } else if (!dealerId) {
        try {
          return await Promise.reject(new Error("missing dealer Id"))
        } catch (err_2) {
          return [err_2, {}]
        }
      }
    },
    true
  )
  if (!process.browser) {
  } else if (retailer?.establishment && retailer.dealer.type !== "SERVICECENTER") {
    if (retailer.establishment.dealerId !== dealerId) {
      navigation.push(err?.redirect ?? "/404")
    }
  }
  if (err) {
    if (!process.browser) {
    } else navigation.push(err?.redirect ?? "/404")
    if (!process.browser) {
      if (err.redirect) throw { status: 301, location: err.redirect }
      else throw { status: 404 }
    }
  }

  // si l'objet retailer.establishment ne remonte pas dans les datas
  // c'est qu'on est sur une page group :
  const isGroupPage = !retailer?.establishment

  const retailerDetails = isGroupPage ? retailer?.dealer : retailer?.establishment

  const rswiDefault = retailerDetails.defaultStoreImages

  const [{ defautStore, defaultImgUrl, searchImages, storeImages }] = useState(() => {
    let defautStore
    let defaultImgUrl
    let searchImages
    let storeImages

    for (let index = 0; index <= retailerDetails?.establishments?.length || 0; index++) {
      if (retailerDetails.rolexId === rswiDefault) {
        defautStore = retailerDetails?.establishments
        break
      }
      retailerDetails.establishments.map(item => {
        if (item.rolexId === rswiDefault) {
          defaultImgUrl = item.storeImages
          try {
            searchImages = JSON.parse(defaultImgUrl)
          } catch (e) {
            searchImages = []
          }
        }
      })
      break
    }

    storeImages = searchImages?.find?.(o => o.type === "cover-v6-mobile") || null

    try {
      if (!storeImages && retailerDetails) storeImages = JSON.parse(retailerDetails?.storeImages)?.find?.(o => o.type === "cover-v6-mobile") || null
    } catch (e) {
      // api's response is different for all images so we have to catch the storeimages different ways
    }

    return { defautStore, defaultImgUrl, searchImages, storeImages }
  }, [])

  const showGroupEntry = retailer?.dealer?.nbrEstablishment > 1 ? false : true

  // map in subnav and add the default store image (cover-v6-mobile)
  if (storeImages?.url) {
    if (sub_nav.reference?.[0].cards?.find(c => c.link === "/rolex-dealers/:dealer/:establishment")?.image?.sources?.[0]) {
      sub_nav.reference[0].cards.find(c => c.link === "/rolex-dealers/:dealer/:establishment").image.sources[0].src = storeImages?.url
    }
    if (sub_nav_two.reference?.[0].cards?.find(c => c.link === "/rolex-dealers/:dealer/:establishment")?.image?.sources?.[0]) {
      sub_nav_two.reference[0].cards.find(c => c.link === "/rolex-dealers/:dealer/:establishment").image.sources[0].src = storeImages?.url
    }
  }

  if (controlsLayout)
    Object.assign(header, {
      children:
        retailCat === "/dealer/" ? (
          <Pane
            establishmentRetail={retailer /*?.establishment ? retailer?.establishment : retailer?.dealer*/}
            isDealer={isDealer}
            {...sub_nav.reference[0]}
            cards={sub_nav.reference[0].cards}
            toggle_label={sub_nav.reference[0].toggle_label}
            locate={locate}
            showGroupEntry={showGroupEntry}
          />
        ) : (
          <Pane
            establishmentRetail={retailer /*.establishment ? retailer?.establishment : retailer?.dealer*/}
            isDealer={isDealer}
            {...sub_nav_two.reference[0]}
            cards={sub_nav_two.reference[0].cards}
            toggle_label={sub_nav_two.reference[0].toggle_label}
            locate={locate}
            showGroupEntry={showGroupEntry}
          />
        ),
    })

  const JSX = (
    <>
      {retailerSSR}
      <StaticRouter location={location}>
        <Switch>
          <Route path={"/dealer/group"}>
            <Suspense>
              <Group location={location} isDealer={isDealer} establishmentRetail={retailer} dealer={retailer?.dealer} {...props} />
            </Suspense>
          </Route>
          <Route path={["/dealer/establishement", "/service/establishement"]}>
            <Suspense>
              <Establishment
                locate={locate}
                establishmentRetail={retailer}
                isDealer={isDealer}
                dealer={retailer?.dealer}
                establishment={retailer?.establishment}
                isGroupPage={isGroupPage}
                {...props}
              />
            </Suspense>
          </Route>
          {/* Buy page is removed V7-4340 */}
          {/* <Route path={"/dealer/purchasing-a-rolex"}>
            <Suspense>
              <Buy isDealer={isDealer} establishmentRetail={retailer} {...props} />
            </Suspense>
          </Route> */}
          <Route path={"/dealer/purchasing-a-rolex"}>
            <Suspense>
              <Purchasing isDealer={isDealer} establishmentRetail={retailer} {...props} />
            </Suspense>
          </Route>
          <Route path={"/dealer/the-rolex-guarantee"}>
            <Suspense>
              <Guarantee isDealer={isDealer} establishmentRetail={retailer} {...props} />
            </Suspense>
          </Route>
          <Route path={["/dealer/caring-for-your-rolex", "/service/caring-for-your-rolex"]}>
            <Suspense>
              <Caring isDealer={isDealer} establishmentRetail={retailer} {...props} />
            </Suspense>
          </Route>
          <Route path={["/dealer/servicing-your-rolex", "/service/servicing-your-rolex"]}>
            <Suspense>
              <Servicing isDealer={isDealer} establishmentRetail={retailer} {...props} />
            </Suspense>
          </Route>
        </Switch>
      </StaticRouter>
    </>
  )

  const title = page.meta.title
    .replace("%dealer%", retailer.dealer.name)
    .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
    .replace("%address%", retailer.establishment?.shortAddress ?? "")
    .replaceAll("<br/>", " ")
  const description = page.meta.description
    .replace("%dealer%", retailer.dealer.name)
    .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
    .replace("%address%", retailer.establishment?.address ?? "")
    .replaceAll("<br/>", " ")
  const ogDescription = page.meta.description_og
    .replace("%dealer%", retailer.dealer.name)
    .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
    .replace("%address%", retailer.establishment?.address ?? "")
    .replaceAll("<br/>", " ")
  const ogTitle = page.meta.title_og
    .replace("%dealer%", retailer.dealer.name)
    .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
    .replace("%address%", retailer.establishment?.address ?? "")
    .replaceAll("<br/>", " ")
  const image = page.meta.image_og
    .replace("%dealer%", retailer.dealer.name)
    .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
    .replace("%address%", retailer.establishment?.address ?? "")
    .replaceAll("<br/>", " ")
  const searchimage = new URL(storeImages?.url, env.content)
  const ogSearchimage = searchimage
  const searchSection =
    page.meta.search_section &&
    page.meta.search_section
      .replace("%dealer%", retailer.dealer.name)
      .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
      .replace("%address%", retailer.establishment?.address ?? "")
      .replaceAll("<br/>", " ")
  const searchTitle =
    page.meta.search_title &&
    page.meta.search_title
      .replace("%dealer%", retailer.dealer.name)
      .replace("%establishment%", retailer.establishment?.nameTranslated ?? "")
      .replace("%address%", retailer.establishment?.address ?? "")
      .replaceAll("<br/>", " ")

  // structured data
  let ldJson = null
  if (!isGroupPage) {
    const weekDaysDict = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    console.log("🚀 ~ file: Retailer.js:287 ~ BootstrapRetailer ~ retailer:", retailer)
    const daysGroupedByOpeningHours = retailer?.establishment?.hoursTranslatedDetails?.reduce((acc, day) => {
      const key = day.hoursDayTranslated
      const curGroup = acc[key] && acc[key].dayOfWeek ? acc[key].dayOfWeek : []
      return {
        ...acc,
        [key]: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [...curGroup, weekDaysDict[day.dayId - 1]],
          opens: day.open1,
          closes: day.close1,
        },
      }
    }, {})
    console.log("🚀 ~ file: Retailer.js:299 ~ daysGroupedByOpeningHours ~ daysGroupedByOpeningHours:", daysGroupedByOpeningHours)
    const daysGroupedByOpeningHoursArray = []
    for (const [key, value] of Object.entries(daysGroupedByOpeningHours)) {
      daysGroupedByOpeningHoursArray.push({ ...value, dayOfWeek: value.dayOfWeek.length === 1 ? value.dayOfWeek[0] : value.dayOfWeek })
    }
    ldJson = {
      "@context": "https://schema.org",
      "@type": "STORE",
      name: retailer?.dealer?.name,
      url: `/rolex-dealers/${retailer?.establishment?.urlRolexV7}`,
      telephone: retailer?.establishment?.dealerPhone || retailer?.establishment?.phone1,
      address: {
        "@type": "PostalAddress",
        streetAddress: retailer?.establishment?.streetAddress,
        addressLocality: retailer?.establishment?.cityName,
        postalCode: retailer?.establishment?.postalCode,
        addressCountry: retailer?.establishment?.countryName,
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: retailer?.establishment?.lat,
        longitude: retailer?.establishment?.lng,
      },
      openingHoursSpecification: daysGroupedByOpeningHoursArray,
      isRCPO: retailer?.establishment?.isRCPO && !retailer?.establishment?.isHiddenRCPO === "RCPO",
    }
  }

  // format breadcrumb
  if (!!footer?.breadcrumb && footer?.breadcrumb.length > 0 && !!footer?.breadcrumb[1] && Object.entries(footer?.breadcrumb[1]).length > 0) {
    if (footer?.breadcrumb[1]?.href) {
      const hrefArray = footer.breadcrumb[1].href
        .split("/")
        .map(p => {
          if (p === "%dealer%") {
            if (retailer?.dealer && !retailer?.establishment) {
              return retailer?.dealer?.urlRolexV7
            } else {
              return null
            }
          }
          if (p === "%establishment%") {
            if (retailer?.establishment) {
              return retailer?.establishment?.urlRolexV7
            } else {
              return null
            }
          }
          return p
        })
        .filter(Boolean)
      footer.breadcrumb[1].href = hrefArray.join("/")
    }

    if (footer?.breadcrumb[1]?.title) {
      let dealerTitle = footer.breadcrumb[1].title
      if (footer.breadcrumb[1].title === "%dealer%") {
        if (retailer?.dealer && !retailer?.establishment) {
          dealerTitle = retailer?.dealer?.name.replace(/<br\/>/g, " ")
        }
      }
      if (footer.breadcrumb[1].title === "%establishment%") {
        if (retailer?.establishment) {
          dealerTitle = retailer?.establishment?.nameTranslated.replace(/<br\/>/g, " ")
        }
      }
      footer.breadcrumb[1].title = dealerTitle
    }
  }

  console.verbose("BootstrapRetailer(%o)", {
    footer,
    retailer,
    rswi,
    dealerId,
    establishment,
    searchimage,
  })

  useEffect(() => {
    if (!process.browser) return

    const nameTranslated = dealerId ? retailer?.dealer?.establishments[0]?.nameTranslated : retailer?.establishment?.nameTranslated
    const urlRolexV7 = dealerId ? retailer?.dealer?.establishments[0]?.urlRolexV7 : retailer?.establishment?.urlRolexV7
    const retailerData = {
      name: nameTranslated,
      url: `/rolex-dealers/${urlRolexV7}`,
    }

    handleVisitor({
      type: "retailer",
      randomNum: Math.floor(Math.random() * 3) + 1,
      url: navigation.slug,
      rswi,
    })

    const interaction = localStorage?.getItem?.("rlx_ddl_retailer_interaction")
    const retailerInfo = Object.assign(
      {
        id: isGroupPage ? retailer?.dealer?.id : retailer?.establishment?.rolexId,
        type: isGroupPage ? "dealer" : retailer?.establishment?.type.toLowerCase(),
        previewsComponent: global.location.pathname.includes("/service-centre") ? "service locator page" : "store locator page",
      },
      interaction && { interaction }
    )
    localStorage?.removeItem?.("rlx_ddl_retailer_interaction")
    localStorage?.setItem("retailerInfo", JSON.stringify(retailerInfo))
    startTransition(() => props?.pageviewCallback?.())
  })

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name='description' content={description} />
        {ogDescription && <meta name='og:description' content={ogDescription} />}
        {ogTitle && <meta name='og:title' content={ogTitle} />}
        <meta name='image' content={image} />
        <meta name='searchimage' content={searchimage} />
        {ogSearchimage && <meta name='og:searchimage' content={ogSearchimage} />}
        {searchSection && <meta name='search_section' content={searchSection} />}
        {searchTitle && <meta name='search_title' content={searchTitle} />}
        {!isGroupPage && !!ldJson && <script type='application/ld+json'>{JSON.stringify(ldJson)}</script>}
      </Helmet>
      {controlsLayout && generateComponents(header, { console })}
      {controlsLayout ? <main>{JSX}</main> : JSX}
      {controlsLayout && !nofooter && generateComponents(footer, { console })}
    </>
  )
}
